import type {
  SecondaryPostEventsCpOrderPersistedTabContent,
  SecondaryQuotesCpOrderPersistedTabContent,
} from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

import type {
  SecondaryMarketCpOrderField,
  SecondaryMarketCpOrderForm,
  SecondaryMarketCpOrderFormTabContent,
} from './cpOrderInputForm.model';

export type SecondaryMarketCpOrderInputFormActions =
  | SecondaryMarketCpOrderFormTabFetched
  | SecondaryMarketCpOrderFormFieldChanged
  | SecondaryMarketCpOrderTabContentPersistRequested
  | SecondaryMarketCpOrderTabContentPersisted
  | SecondaryMarketCpOrderFormReset;

/////////////////////////////////////////////

// Tab fetched (workspace loaded), but not yet tab content (will be loaded later when the user select it)
export function secondaryMarketCpOrderFormTabFetched(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_FORM_TAB_FETCHED' as const,
    tabId,
  };
}
export type SecondaryMarketCpOrderFormTabFetched = ReturnType<typeof secondaryMarketCpOrderFormTabFetched>;

/////////////////////////////////////////////

export function secondaryMarketCpOrderFormFieldChanged<F extends SecondaryMarketCpOrderField>(
  tabId: string,
  field: F,
  value: SecondaryMarketCpOrderForm[F],
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_FORM_FIELD_CHANGED' as const,
    tabId,
    field,
    value,
  };
}
export type SecondaryMarketCpOrderFormFieldChanged = ReturnType<typeof secondaryMarketCpOrderFormFieldChanged>;

export function secondaryMarketCpOrderFormReset(tabId: string) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_FORM_RESET' as const,
    tabId,
  };
}
export type SecondaryMarketCpOrderFormReset = ReturnType<typeof secondaryMarketCpOrderFormReset>;

export function secondaryMarketCpOrderTabContentPersistRequested(
  tabId: string,
  workspace: SecondaryWorkspaceType,
  tabContent: SecondaryQuotesCpOrderPersistedTabContent | SecondaryPostEventsCpOrderPersistedTabContent,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_TAB_CONTENT_PERSIST_REQUESTED' as const,
    tabId,
    workspace,
    tabContent,
  };
}
export type SecondaryMarketCpOrderTabContentPersistRequested = ReturnType<
  typeof secondaryMarketCpOrderTabContentPersistRequested
>;

/////////////////////////////////////////////

export function secondaryMarketCpOrderTabContentPersisted(
  tabId: string,
  workspace: SecondaryWorkspaceType,
  tabContent: SecondaryMarketCpOrderFormTabContent,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_TAB_CONTENT_PERSISTED' as const,
    tabId,
    workspace,
    tabContent,
  };
}

export type SecondaryMarketCpOrderTabContentPersisted = ReturnType<typeof secondaryMarketCpOrderTabContentPersisted>;
